import { APICore } from './apiCore'

const api = new APICore()

function getTiposNoticia (params) {
  const baseUrl = '/tipos-noticia'
  return api.get(baseUrl, params)
}

function getTipoNoticia (id) {
  const baseUrl = `/tipos-noticia/${id}`
  return api.get(baseUrl, {})
}

function addTipoNoticia (params) {
  const baseUrl = '/tipos-noticia'
  return api.create(baseUrl, params)
}

function updateTipoNoticia (params) {
  const baseUrl = '/tipos-noticia'
  return api.update(baseUrl, params)
}

function deleteTipoNoticia (params) {
  const baseUrl = '/tipos-noticia'
  return api.delete(baseUrl, params)
}

export { getTiposNoticia, getTipoNoticia, addTipoNoticia, updateTipoNoticia, deleteTipoNoticia }
